<template xmlns="http://www.w3.org/1999/html">
    <div class="animated fadeIn" id="jira-worklogs">
        <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-block">
                        <div v-if="showActions">
                            <b-form @submit.prevent="filterInput">
                                <div class="form-group row">
                                    <div class="col-md-2">
                                        <label class="col-form-label">Timeframe</label>
                                        <select id="timeframe-select" v-model="currentTimeframe">
                                            <option value="week">Week</option>
                                            <option value="month">Month</option>
                                            <option value="quarter">Quarter</option>
                                            <option value="year">Year</option>
                                        </select>
                                    </div>
                                    <div class="col-md-2">
                                        <label class="col-form-label">Period from</label>
                                        <datepicker
                                                placeholder="yyyy-mm-dd"
                                                input-class="worklogs-date-picker"
                                                :disabled-dates="{from: new Date(period.periodTo)}"
                                                v-model="period.periodFrom"
                                                format="yyyy-MM-dd">
                                        </datepicker>
                                    </div>
                                    <div class="col-md-2">
                                        <label class="col-form-label">Period to</label>
                                        <datepicker placeholder="yyyy-mm-dd" input-class="worklogs-date-picker" :disabled="!period.periodFrom" :disabled-dates="{to: new Date(period.periodFrom)}" v-model="period.periodTo" format="yyyy-MM-dd"></datepicker>
                                    </div>
                                    <div class="col-md-2">
                                        <label class="col-form-label">Filter records</label>
                                        <b-button id="filter-button" type="submit" variant="primary">Filter</b-button>
                                    </div>
                                </div>
                            </b-form>
                        </div>
                        <div v-if="dataLoaded.spinLoader">
                            Loading..
                        </div>
                        <div v-else class="table-view">
                            <table id="worklogs-utilization" class="table table-bordered">
                                <thead>
                                <tr class="tr-full-width">
                                    <th rowspan="2" class="first-column">
                                        User
                                    </th>
                                    <th v-for="date in calendar"
                                        :colspan="isCurrentWeek(date) ? '2' : '1'"
                                        :rowspan="2"
                                        :class="isCurrentWeek(date) ? 'curweek' : ''"
                                        class="table-data table-head-th"
                                    >
                                        <small><b>{{date.indexToView}}</b></small><br />
                                        <small class="text-nowrap export-in-csv">{{date.string}}</small><br />
                                        <small v-if="isCurrentWeek(date)">
                                            {{ actualDateDay }} | {{ futureStartOfDate }}
                                        </small>
                                    </th>
                                    <th class="table-head-th" colspan="3">
                                        Totals
                                    </th>
                                </tr>
                                <tr>
                                    <th class="d-none"></th>
                                    <th v-for="date in calendar" :class="date.dateIndex === actualDate ? 'split d-none' : 'd-none'"></th>
                                    <th class="d-none"></th>
                                    <th class="text-right table-head-th">Total</th>
                                    <th class="text-right table-head-th">Available</th>
                                    <th class="text-right table-head-th">Utilization</th>
                                </tr>
                                </thead>
                                <tbody>
                                <WorklogsUserRow
                                        v-for="(logs, user) in jiraWorklogs"
                                        v-if="users[logs.user_id].enabled"
                                        :plannedWorkloads="plannedWorkloads"
                                        :logs="logs"
                                        :userId="logs.user_id"
                                        :key="logs.user_id"
                                        :showHours="showHours"
                                        :showRateTime="showRateTime"
                                        :showTotalPlanned="showTotalPlanned"
                                        :allowExpanding="true"
                                        :timeframe="currentTimeframe"
                                        :showWorkloadPlanner="false"
                                        :utilization="true"
                                        :workingHours="workingHours"
                                        :calendar="calendar"
                                >
                                </WorklogsUserRow>
                                <!--<tr>
                                    <td>Totals:</td>
                                    <td v-for="date in calendar" >date</td>
                                    <td>1</td>
                                    <td>2</td>
                                    <td>3</td>
                                </tr>-->
                                </tbody>
                            </table>
                            <b-button @click="this.exportHTMLDomToCSV">Download CSV</b-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import { mapGetters, mapActions, mapState } from 'vuex';
import Datepicker from 'vuejs-datepicker';
import WorklogsUserRow from './WorklogsUserRow';

export default {
  name: 'WorklogsPersons',
  components: {
    WorklogsUserRow,
    Datepicker
  },
  props: {
    projectId: {
      required: false
    },
    showActions: {
      type: Boolean,
      default: true
    },
  },
  data: function () {
    return {
      showHours: true,
      showRateTime: false,
      showTotalPlanned: true,
      period: {
        periodFrom: moment().subtract(30, 'days').format('YYYY-MM-DD'),
        periodTo: moment().format('YYYY-MM-DD'),
      },
      choosenPastButton: null,
      choosenFutureButton: null,
      hoursOrExpenses: {
        type: 'hours',
        name: 'Hours/Hours*rate'
      },
      hours: {
        type: 'hours',
        name: 'Hours'
      },
      expenses: {
        type: 'rates',
        name: 'Hours*rate'
      },
      jiraWorklogs: [],
      currentTimeframe: 'week',
      plannedWorkloads: {},
      dataLoaded: {
        worklogs: false,
        workloads: false,
        spinLoader: true,
      },
      businessDays: 0,
      workingHours: 0,
      totals: {
        total: 0,
        byPeriods: {},
        totalAvailable: 0
      },
      futureStartOfDate: ''
    };
  },
  watch: {
    worklogs: {
      handler: function (val) {
        const jiraWorklogs = this.worklogsByAuthor;
        for (const i in jiraWorklogs) {
          jiraWorklogs[i].user_id = i;
          jiraWorklogs[i].user_name = this.users[i].displayName;
          jiraWorklogs[i].workload = this.users[i].workload;
        }
        const totalTemplate = {};
        for (const i in jiraWorklogs) {
          for (const k in jiraWorklogs[i]) {
            totalTemplate[k] = { expenses: 0, time: 0 };
          }
          break;
        }
        for (const usrKey in this.users) {
          const user = this.users[usrKey];
          if (usrKey in jiraWorklogs) {
            continue;
          } else if (user.enabled == 1) {
            jiraWorklogs[usrKey] = {};
            jiraWorklogs[usrKey].byProject = {};
            jiraWorklogs[usrKey].total = totalTemplate;
            jiraWorklogs[usrKey].user_id = usrKey;
            jiraWorklogs[usrKey].workload = user.workload;
            jiraWorklogs[usrKey].user_name = user.displayName;
          }
        }

        this.jiraWorklogs = Object.values(jiraWorklogs).sort((a, b) => { return (a.user_name > b.user_name) ? 1 : ((b.user_name > a.user_name) ? -1 : 0); });
        this.dataLoaded.worklogs = true;
        this.checkStatus;
      },
      deep: true
    },
    workloads: {
      handler: function (val) {
        this.dataLoaded.workloads = true;
        this.checkStatus;
      },
      deep: true
    },
    specialBusinessDaysByPeriod: {
      handler: function (val) {
        this.calculateBusinessDays();
        this.workingHours = this.businessDays * 8 + this.specialBusinessDaysByPeriod.total_hours;
      },
      deep: true
    },
    actualDateDay: {
      handler: function (date) {
        this.futureStartOfDate = moment(date).add(1, 'day').format('YYYY-MM-DD');
      }
    }
  },
  computed: {
    ...mapGetters('Worklogs', [
      'worklogsByAuthor',
      'calendar',
      'timeframe',
      'offset',
      'count',
      'actualDate',
      'actualDateDay',
      'worklogs'
    ]), // ...mapGetters('WorkloadPlans', ['workloadsByUserByYearweekByProject']),
    ...mapGetters('WorkloadPlans', [
      'workloadsByUserByYearweekByProject',
      'workloadsByUserByMonthByProject',
      'workloadsByUserByQuarterByProject',
      'workloadsByUserByYearByProject',
      'workloadsByUserByYearweekByProject',
      'workloads']),
    ...mapGetters('SpecialBusinessDays', ['specialBusinessDaysByPeriod']),
    ...mapGetters('JiraUsers', ['users']),
    checkStatus() {
      if (this.dataLoaded.worklogs == true && this.dataLoaded.workloads == true) {
        this.calculateTotalPlanned();
        this.calculateBusinessDays();
        this.calculateTotals;
        this.dataLoaded.spinLoader = false;
      }
    },
    calculateTotals() {
      this.calendar.forEach((date) => {

      });
    }
  },
  methods: {
    ...mapActions({
      loadLogs: 'Worklogs/LOAD_JIRA_WORKLOGS', // map `this.add()` to `this.$store.dispatch('increment')`
      loadWorklogsByPeriodTimeframe: 'Worklogs/LOAD_WORKLOGS_BY_PERIOD_TIMEFRAME',
      loadPlannedWorkload: 'WorkloadPlans/LOAD_PLANNED_WORKLOADS',
      loadSpecialDaysByPeriod: 'SpecialBusinessDays/LOAD_SPECIAL_DAYS_BY_PERIOD'
    }),
    ...mapActions('JiraUsers', ['LOAD_JIRA_USERS']),
    calculateTotalPlanned() {
      let plannedWorkloads;
      switch (this.timeframe) {
        case 'week':
          plannedWorkloads = this.workloadsByUserByYearweekByProject;
          break;
        case 'month':
          plannedWorkloads = this.workloadsByUserByMonthByProject;
          break;
        case 'quarter':
          plannedWorkloads = this.workloadsByUserByQuarterByProject;
          break;
        case 'year':
          plannedWorkloads = this.workloadsByUserByYearByProject;
          break;
      }

      //                console.log('plannedWorkloads -> worklogs', plannedWorkloads);
      this.plannedWorkloads = plannedWorkloads;
    },
    toggleHoursOrExpenses(type) {
      if (type == 'hours') {
        this.hoursOrExpenses = this.expenses;
        this.showRateTime = true;
        this.showHours = false;
      } else {
        this.hoursOrExpenses = this.hours;
        this.showRateTime = false;
        this.showHours = true;
      }
    },
    filterInput() {
      for (var i in this.periodPast) {
        this.periodPast[i].enabled = false;
      }
      for (var i in this.periodFuture) {
        this.periodFuture[i].enabled = false;
      }

      this.choosenFutureButton = null;
      this.choosenPastButton = null;

      this.dataLoaded.spinLoader = true;
      this.loadSpecialDaysByPeriod({ periodFrom: this.period.periodFrom, periodTo: this.period.periodTo });
      this.loadWorklogsByPeriodTimeframe({ periodFrom: this.period.periodFrom, periodTo: this.period.periodTo, timeframe: this.currentTimeframe });
      this.calculateBusinessDays();
    },
    rateOnDate(date, userId) {
      return this.$store.getters['UserRates/ratesOnDate'](date, userId);
    },
    isCurrentWeek(date) {
      return date.index == this.actualDate;
    },
    exportHTMLDomToCSV() { // not good not bad
      const filename = 'worklogs-utilization.csv';
      const csv = [];
      const rows = this.$el.querySelectorAll('table#worklogs-utilization tr');

      for (let i = 0; i < rows.length; i++) {
        const row = [];
        const cols = rows[i].querySelectorAll('td, th');

        for (let j = 0; j < cols.length; j++) {
          row.push(`"${cols[j].innerText}"`);
        }

        csv.push(row.join(','));
      }

      const csvFile = new Blob([csv.join('\n')], { type: 'text/csv' });
      const downloadLink = document.createElement('a');
      downloadLink.download = filename;
      downloadLink.href = window.URL.createObjectURL(csvFile);
      downloadLink.style.display = 'none';
      document.body.appendChild(downloadLink);
      downloadLink.click();
    },
    calculateBusinessDays(dateFrom, dateTo) {
      const fromDate = moment(this.period.periodFrom);
      const toDate = moment(this.period.periodTo);
      let oneToFiveWorkdays = 0;

      for (let m = fromDate; m.isSameOrBefore(toDate); m.add(1, 'days')) {
        if (m.day() !== 6 && m.day() !== 0) {
          oneToFiveWorkdays++;
        }
      }

      this.businessDays = oneToFiveWorkdays;
    }
  },
  mounted() {
    this.LOAD_JIRA_USERS();
    this.loadPlannedWorkload();
    this.loadSpecialDaysByPeriod({ periodFrom: this.period.periodFrom, periodTo: this.period.periodTo });
    this.loadWorklogsByPeriodTimeframe({ periodFrom: this.period.periodFrom, periodTo: this.period.periodTo, timeframe: this.currentTimeframe });
  },
};

</script>

<style scoped>
    #timeframe-select {
        background-color: #ffffff;
        width: 100%;
        border: 1px solid rgba(0, 0, 0, 0.15);
        color: #607d8b;
        padding: 0.6rem 0.75rem;
    }

    .table-condensed td {
        padding: 0;
    }
    .table thead th {
        padding: 0.5rem;
    }
    .table-head-th {
        min-width: 80px;
        position: sticky;
        position: -webkit-sticky;
        top: 0;
        z-index: 1;
        background: white;
    }
    .curweek{
        font-weight: bold;
    }
    .table-data{
        text-align: right;
    }
    .button-days{
        margin-right: 2px;
    }
    /* .userrow:hover {
        background-color: #efefef
    } */
    /*.table {*/
    /*height: 800px;*/
    /*}*/
    .table-view {
        overflow: auto;
        position: relative;
        max-width: 1500px;
        max-height: 800px;
    }
    @media only screen  and (min-width : 1304px) {
        .table-view {
            max-width: 1500px;
        }
    }
    @media only screen  and (max-width : 1303px) {
        .table-view {
            max-width: 950px;
        }
    }
    /*thead .tr-full-width {*/
    /*width: 100%;*/
    /*display: inline-table;*/
    /*!*height:100px;*!*/
    /*table-layout: fixed;*/
    /*}*/
    /*tbody{*/
    /*overflow-y: scroll;*/
    /*max-height: 200px;*/
    /*position: absolute;*/
    /*}*/

    /*thead .tr-full-width {*/
    /*width: 100%;*/
    /*display: inline-table;*/
    /*!*height:100px;*!*/
    /*table-layout: fixed;*/
    /*}*/
    .first-column {
        width: 200px;
        min-width: 200px;
        /*position: absolute;*/
        position: sticky;
        position: -webkit-sticky;
        left: 0;
        z-index: 2;
        top: 0;
        vertical-align: middle;
        background: white;
    }
    .hours-enabled {
        color: red;
    }
    .rates-enabled {
        color: red;
    }
    .btn-success {
        background-color: #3a9d5d;
        border-color: #379558;
    }

    #filter-button {
        display: flex;
    }
</style>
<style>
    .worklogs-date-picker {
        width: 100%;
        border: 1px solid rgba(0, 0, 0, 0.15);
        color: #607d8b;
        padding: 0.5rem 0.75rem;
    }
</style>
